import React from 'react';

const SnakeShape1 = ({ className }) => {
  return (
    <svg 
      className={className}
      width="304" 
      height="681" 
      viewBox="0 0 304 681" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M6.22098 -80.1474C-5.50455 -30.8289 11.0016 55.7069 61.6992 101.561C107.284 142.79 147.789 164.733 204.934 195.546C244.079 216.653 328.749 251.813 291.894 315.67C255.039 379.528 20.4996 595 71.8747 740.125" 
        stroke="#EFBE74" 
        stroke-width="4.5"
      />
    </svg>
  );
};

export default SnakeShape1;
